module.exports = __webpack_public_path__ + "static/img/pic-faq2.ad608f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/pic-faq2.png
// module id = 986
// module chunks = 0